<body>
<div class="content">
    <div #div1 class="side-nav-container" [@slideInOut]="{value: animationState, params:{inWidth: farmWidth}}">
        <div *ngIf="animationState === 'in'" style="display: flex;flex-direction: column;height: 100%">
            <div class="farm-selection-title">
                <span class="list-title-text">Farm Selection</span>

                <button mat-icon-button class="close-button" (click)="toggleFarms(div1.offsetWidth)">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <button class="overview-button" routerLink="/tenant-view">
                <div></div>
                View All Farms
                <mat-icon style="justify-self: flex-end">chevron_right</mat-icon>
            </button>

<!--            <mat-form-field class="search-bar" floatLabel="always" appearance="outline">-->
<!--                <mat-icon matPrefix>search</mat-icon>-->
<!--                <input type="tel" matInput placeholder="Search..." (ngModelChange)="onFarmSearch($event)"-->
<!--                       [(ngModel)]="selectedFarm">-->
<!--            </mat-form-field>-->

            <div class="farm-list-container" (scroll)="onScrollCloseOptions()">
                <div *ngFor="let farm of filteredFarms; let i = index">
                    <div class="farm-container"
                         style="cursor: pointer"
                         [ngStyle]="{'margin-bottom': farm.id === activeId && fields?.length > 0 && this.farmOpened ? '0' : ''}"
                         [ngClass]="{'active-farm-item-new': farm.id === activeId, 'farm-item-new': farm.id !== activeId}">
                        <div (click)="overlayBoundaryForSelectedFarm(farm.id, farm.name, farm.numberOfFields, farm.size,farm.field, true)" style="width: 100%;display: flex;flex-direction: row;align-items: center; padding: 15px 0 15px 15px">
                            <mat-icon style="margin-right: 20px">{{farm.id === activeId && farmOpened ? 'expand_less' : 'expand_more'}}</mat-icon>
                            <div style="width: 100%; display: flex;flex-direction: column;align-items: start">
                                <div class="farm-heading-info-new">
                                    <span class="farm-heading-new">{{farm?.name.length > 30 ? ( farm.name | slice:0:30) + '...' : farm.name}}</span>
                                    <span class="field-size"> | {{ farm.size | number : '1.2-2' }} HA</span>
                                </div>

                                <span class="field-count">{{ farm.country }} | {{ farm.province}} | Field: {{ farm.numberOfFields }}</span>
                            </div>
                        </div>

                        <mat-icon style="padding-right: 12px;" class="options-icon" [matMenuTriggerFor]="farmMenu">more_vert</mat-icon>

                        <mat-menu class="myMenu" #farmMenu="matMenu" xPosition="after">
                            <button (click)="openFarmNameEditor(farm)" mat-menu-item>
                                <span class="mat-label">{{ 'FIELD-OPTIONS-DIALOG.CHANGE-NAME' | translate }}</span>
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button (click)="deleteFarm(farm.id)" mat-menu-item>
                                <span class="mat-label" style="color: red">{{ 'MAPPING.DELETE-FARM' | translate }}</span>
                                <mat-icon style="color: red">delete</mat-icon>
                            </button>
                        </mat-menu>
                    </div>
                    <div *ngIf="farm.id === activeId && fields?.length > 0 && farmOpened" style="margin-bottom: 15px">
                        <div *ngFor="let field of fields">
                            <div class="field-container">
                                <div class="farm-heading-info-new" style="cursor: pointer" (click)="placeMarker(null, field.id, field.name, false)">
                                    <span class="farm-heading-new">{{field?.name.length > 30 ? ( field.name | slice:0:30) + '...' : field.name}}</span>
                                    <span class="field-size"> | {{ field.size | number : '1.2-2' }} HA</span>
                                </div>

                                <mat-icon class="options-icon" [matMenuTriggerFor]="menu">more_vert</mat-icon>

                                <mat-menu class="myMenu" #menu="matMenu" xPosition="after">
                                    <button (click)="viewFieldDetails(field.id, farm)" mat-menu-item>
                                        <span class="mat-label">View Details</span>
                                        <mat-icon>panorama</mat-icon>
                                    </button>
                                    <button (click)="openDeleteFieldDialog(field, i)" mat-menu-item>
                                        <span class="mat-label" style="color: red">Delete Field</span>
                                        <mat-icon style="color: red">delete</mat-icon>
                                    </button>
                                </mat-menu>
                            </div>

                            <mat-divider></mat-divider>
                        </div>
                    </div>
                </div>

                <button mat-button class="add-farm-button" (click)="addFarm()">
                    <mat-icon style="font-size: 18px;color: #333333">add</mat-icon>
                    <span class="add-farm-button-text">{{ 'MAPPING.ADD-FARM' | translate }}</span>
                </button>
            </div>
        </div>

        <div class="expand-farm-list-button-container" *ngIf="animationState === 'out'">
            <button style="width: 30px" class="expand-farm-list-button" (click)="toggleFarms(div1.offsetWidth)" mat-icon-button>
                <mat-icon style="color: white">chevron_right</mat-icon>
            </button>
        </div>

    </div>
    <div #div2 class="div2">
        <div class="container">
            <div *ngIf="oneAction" class="map-label-container">
                <div class="action-container">
                    <label class="filter-analysis">{{ action }}</label>
                </div>
            </div>
            <google-map #map
                        (mapClick)="onMapClick($event); isDrawingMode && drawingType === 'polygon' && addDrawingPoint($event.latLng.toJSON())"
                        (mapMousemove)="isDrawingMode && drawingType === 'polygon' && drawnPoints.length > 0 && updatePreviewLine($event.latLng.toJSON())"
                        (mapMousedown)="isDrawingMode && drawingType === 'circle' && startCircleDrawing($event.latLng.toJSON())"
                        (mapDblclick)="getVardaBoundary($event, map)" [center]="center" [zoom]="zoom" [options]="options"
                        width="100%" height="100%">

                <map-ground-overlay *ngFor="let object of images" [url]="object.image" [bounds]="object.bounds"
                                    [opacity]="opacity">
                </map-ground-overlay>

                @for (marker of markers; track $index) {
                    <map-advanced-marker class="marker"
                        [position]="marker.position" [content]="marker?.content" [title]="marker.title" (mapClick)="infoClick(marker, marker.id, marker.title)">
                    </map-advanced-marker>
                }

                <map-polygon *ngFor="let polygon of polygons" [paths]="polygon.points" [options]="polygonOptions"
                             (polygonDblclick)="placeMarker($event, polygon.id, polygon.fieldName, true)"
                             (polygonClick)="placeMarker(null, polygon.id, polygon.fieldName, false)" clickable="true" ></map-polygon>

                <div *ngIf="isDrawingMode" class="drawing-toolbar">
                    <div class="drawing-toolbar-buttons">
                    <button mat-flat-button
                            [style.color]="'white'"
                            [style.background]="drawingType !== 'polygon' ? 'transparent' : ''"

                            [style.borderRight]="'1px solid rgba(255,255,255,0.2)'"
                            [style.borderRadius]="'0'" (click)="switchDrawingType('polygon')"
                            type="button">
                        <mat-icon>pentagon</mat-icon>
                        Polygon


                    </button>
                    <button mat-flat-button
                            [style.color]="'white'"
                            [style.background]="drawingType !== 'circle' ? 'transparent' : ''"

                            [style.borderRight]="'1px solid rgba(255,255,255,0.2)'"
                            [style.borderRadius]="'0'" (click)="switchDrawingType('circle')"
                            type="button">
                        <mat-icon>circle</mat-icon>
                        Circle


                    </button>
                    <button mat-flat-button
                            [style.color]="'white'"

                            [style.background]="drawingType !== null ? 'transparent' : ''"
                            [style.borderRadius]="'0'" (click)="switchDrawingType(null)"
                            type="button">
                        <mat-icon>pan_tool</mat-icon>
                        Move
                    </button>
                </div>
                    <div class="drawing-toolbar-help">
                         <span style="color: white; align-self: center; font-size: 13px;">
                            <ng-container *ngIf="drawingType === 'polygon'">
                                Click to drop points
                            </ng-container>
                            <ng-container *ngIf="drawingType === 'circle'">
                                <ng-container *ngIf="!circleCenter">Double Click to place center</ng-container>
                                <ng-container *ngIf="circleCenter">Drag handles to resize</ng-container>
                            </ng-container>
                            <ng-container *ngIf="drawingType === null">
                                Drag to pan
                            </ng-container>
                        </span>
                    </div>
                </div>
            </google-map>

 <div class="info-container-pin-overlay">

    <div class="container-glass glassMorphism-effect" *ngIf="isPinMarkersVisible && pinCounter !==0" style="pointer-events: auto !important;">
    <div class="box">
    <div class="close-glass" (click)="clearPins()"> <img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon-light"></div>
        <div class="inner-glass-box-container">
        <strong> Pin Type: {{selectedPinType.name}}</strong>
        <p class="text-no-margin" *ngIf="savedPinStartDate || savedPinEndDate">Range:  <span style="min-width: 135px !important;">{{savedPinStartDate}} - {{savedPinEndDate}}</span></p>
       
        </div>
    </div>
    </div>

    <div class="container-glass glassMorphism-effect" *ngIf="!hideAnalysisLabel"  style="pointer-events: auto !important;">
        <div class="box">
            <div class="close-glass" (click)="removeAnalysis()"><img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon-light"></div>
                <div class="inner-glass-box-container">
                    <p class="text-no-margin">{{selectedMapTitleDetails.type}}</p>
                    <p *ngIf="selectedMapTitleDetails.propertyTypeName" class="text-no-margin">{{selectedMapTitleDetails.propertyTypeName}}</p>
                    <p class="text-no-margin">Date:  <span style="min-width: 135px !important;"> {{selectedDate}}</span></p>

                 </div>
            <!-- Farm-level recache: one click, recaches every field behind the overlay currently shown.
                 This component is farm-level only (field-level uses the field/ module's own dialog).
                 Placed after the text, not next to the close icon. -->
            <div class="recache-glass" *ngIf="helper.doesUserHaveRole('RecacheAnalysisMapView') && selectedFarmMapsItemObj?.length"
                 [title]="farmRecaching ? 'Recaching…' : 'Recache all fields shown'"
                 (click)="!farmRecaching && recacheFarmOverlay()">
                <mat-icon class="recache-icon-light" [class.spin-icon]="farmRecaching">autorenew</mat-icon>
            </div>
            </div>
        </div>
 </div>


        <div class="varda-top-container" *ngIf="openVardaBoundary">
            <div class="varda-boundary-container">
                <div class="varda-row" style="gap: 15px">
                    <span class="varda-container-title">Varda Boundary Manager</span>
                    <mat-icon class="info-icon"
                        matTooltip="Double click anywhere on the map to draw a boundary"
                        matTooltipPosition="above">info</mat-icon>
                </div>

                <div class="varda-row" style="gap: 15px">
                    <span *ngIf="vardaFieldSize > 0 ">{{"Approximate Field Size: " + (vardaFieldSize | number:'1.1-2') + " HA"}}</span>
                    <button mat-button class="varda-save-button" (click)="saveVardaBoundary()">SAVE</button>
                    <button mat-stroked-button class="varda-clear-button" (click)="clearVardaBoundary()">CLEAR</button>
                    <mat-icon style="color: white; cursor: pointer" (click)="clearVardaBoundary();openVardaBoundary = false">close</mat-icon>
                </div>
            </div>
        </div>



        <div  id="toggle-main-container">
                <!-- <div class="filter-container" (click)="clearPins()" style="pointer-events: auto !important; cursor:pointer!important;"  *ngIf="isPinMarkersVisible">
                    <div class="filter-container-close" >X</div>
                    <div class="filter-container-content-container">
                    
                    <div style="height: 15px; width:fit-content">  
                        <label class="filter-analysis">Pin Type: {{selectedPinType.name}}</label></div>
                     <div  style="height: 15px; width:fit-content">
                          <label class="filter-dates">{{savedPinStartDate}} - {{savedPinEndDate}}</label>
                     </div>
                    </div>

                </div>
     
                <div class="filter-container" (click)="removeAnalysis()" style="pointer-events: auto !important; cursor:pointer!important;" *ngIf="!hideAnalysisLabel" >
                    <div class="filter-container-close" >X</div>
                    <div class="filter-container-content-container">
                    
                    <div style="height: 15px; width:fit-content">  
                        <label class="filter-analysis">{{ selectedSatImage }}</label></div>
                     <div  style="height: 15px; width:fit-content">
                          <label class="filter-dates">{{selectedDate}}</label>
                     </div>
                    </div> -->

                <!-- </div> -->

                       <button mat-icon-button (click)="openMaps()" id="map-toggle-container" *ngIf="isAnalysisEmpty">
                        <div id="button-content">
                            <div id="history-icon-container">
                                <mat-icon id="expand-rankings">expand_less</mat-icon>
                            </div>
                            <div id="history-label-container">
                                <label id="expand-rankings-label">{{ 'MAPPING.MAPS-DATA' | translate }}</label>
                            </div>
                        </div>
                    </button>
                </div>

                <div class="scrollableLegend-container-farm"  *ngIf="farmLegends.length != 0">
                    <div class="scrollableLegend-farm glassMorphism-effect" *ngIf="!toggleLegend">
                        <div class="inner-legend-container-farm" *ngFor="let farmdLegend of farmLegends">
                            <div class="legend-color-farm" [style.background-color]="farmdLegend.colour"></div>
                            <label class="legend-value-farm">{{ farmdLegend.value }} {{ farmdLegend.area}}</label>
                        </div>
                    </div>

                    <button mat-icon-button id="legends-button" (click)="toggleLegend = !toggleLegend" [ngStyle]="{'margin-top' : !toggleLegend ? '15px' : ''}">
                        <div style="display: flex; flex-direction: row;" >
                            <div id="history-icon-container" style="margin-right: 5px;">
                                <mat-icon id="legend-icon">{{toggleLegend ? 'expand_more' : 'expand_less'}}</mat-icon>
                            </div>
                            <div id="history-label-container">
                                <label id="legends-label">Legends</label>
                            </div>
                        </div>
                    </button>
                </div>


            <eco-fab-speed-dial
                    *ngIf="finishedLoading"
                    class="speed-dial-container">
                <eco-fab-speed-dial-trigger >
                    <button  (click)="openOptions()"  mat-fab label="menu" class="map-menu-circular">
                        <mat-icon  class="material-icons">add</mat-icon>
                    </button>
                </eco-fab-speed-dial-trigger>

                <eco-fab-speed-dial-actions >

                    <!-- <button mat-mini-fab (click)="clearPins()" color="white"  data-title="Remove Pins"
                       aria-label="removePins">
                       <mat-icon class="material-icons">delete_forever</mat-icon>
                   </button> -->

                    <button mat-mini-fab *ngIf="!loadingPins" (click)="newShowSavedPins()" data-title="View Saved Pins"
                            aria-label="SavedPins">
                        <mat-icon class="material-icons">location_on</mat-icon>
                    </button>

                    <button mat-mini-fab *ngIf="!mapping && !notifications" data-title="Enable Farm Notifications"
                            aria-label="farmNotifications"
                            (click)="toggleNotifications()">
                        <mat-icon class="material-icons">notifications_active</mat-icon>
                    </button>
                    <button mat-mini-fab *ngIf="!mapping && notifications" data-title="Disable Farm Notifications"
                            aria-label="farmNotifications"
                            (click)="toggleNotifications()">
                        <mat-icon *ngIf="notifications" class="material-icons">notifications_off</mat-icon>
                    </button>
                    <!-- <button mat-mini-fab *ngIf="mapping" color="white"  data-title="Track Me"
                           aria-label="trackMe" (click)="toggleTracking()">
                        <mat-icon class="material-icons">my_location</mat-icon>
                    </button> -->
<!--                    <button mat-mini-fab *ngIf="!mapping && !editingFields && !noBoundary" color="white" data-title="Edit Field"-->
<!--                            aria-label="edit" (click)="editFields(map)">-->
<!--                        <mat-icon class="material-icons">edit</mat-icon>-->
<!--                    </button>-->
<!--                    <button mat-mini-fab *ngIf="!mapping && editingFields && !noBoundary" color="white" data-title="Close Edit"-->
<!--                            aria-label="closeEdit"-->
<!--                            (click)="stopEditing()">-->
<!--                        <mat-icon class="material-icons">cancel</mat-icon>-->
<!--                    </button>-->

                    <button mat-mini-fab *ngIf="!mapping && !isDrawingMode"  data-title="Add Field"
                            aria-label="addField" (click)="addField(map)">
                        <img class="icon" src="./assets/icons/add_field.png" alt="Add Field"/>
                    </button>
                    <button mat-mini-fab *ngIf="!mapping && isDrawingMode" data-title="Stop Drawing"
                            aria-label="closeAddField"
                            (click)="stopAddingField()">
                        <mat-icon class="material-icons">cancel</mat-icon>
                    </button>

                    <button mat-mini-fab *ngIf="checkFeatureFlag('varda') && !openVardaBoundary && !mapping && themeName?.includes('farm')" data-title="Open Varda Boundary"
                            aria-label="vardaBoundary"
                            (click)="openVardaBoundary = true">
                        <mat-icon class="material-icons">auto_fix_high</mat-icon>
                    </button>
                    <button mat-mini-fab *ngIf="openVardaBoundary && !mapping && themeName?.includes('farm')" data-title="Close Varda Boundary"
                            aria-label="closeBoundary"
                            (click)="openVardaBoundary = false;clearVardaBoundary()">
                        <mat-icon class="material-icons">cancel</mat-icon>
                    </button>

                    <button mat-mini-fab color="white"  data-title="Hide/Show Field Labels"
                            aria-label="showFieldLabels" (click)="toggleLabels()">
                            <mat-icon class="material-icons">label_outline</mat-icon>
                        </button>

                        <button mat-mini-fab data-title="Hide/Show Pin Labels"
                        aria-label="showPinLabels" (click)="togglePinLabels()">
                        <!-- <mat-icon class="material-icons">label_off</mat-icon> -->
                         <img class="icon" src="./assets/icons/flag_label.svg" alt="Add Field"/>
                    </button>

                    <button mat-mini-fab data-title="Capture Rainfall"
                            aria-label="captureRainfall" (click)="captureRainfall()">
                        <mat-icon class="material-icons">grain</mat-icon>
                    </button>
                </eco-fab-speed-dial-actions>
            </eco-fab-speed-dial>
        </div>

        <!-- Weather Forecast Button and Card -->
        <div *ngIf="isWeatherForecastEnabled && activeId > 1" class="weather-forecast-wrapper">
            <button mat-mini-fab class="weather-forecast-btn" (click)="toggleWeatherForecast()" 
                    *ngIf="!showWeatherCard" aria-label="Weather Forecast">
                <mat-icon class="material-icons">cloud</mat-icon>
            </button>
            <div *ngIf="showWeatherCard" class="weather-forecast-card">
                <app-weather-forecast 
                    [forecasts]="weatherForecasts" 
                    [isLoading]="isWeatherLoading"
                    (dismiss)="toggleWeatherForecast()">
                </app-weather-forecast>
            </div>
        </div>
    </div>

    <div *ngIf="saveFields" class="toggle-main-button">
        <button class="update-fields" mat-flat-button (click)="updateFields()" type="button">{{ 'MAPPING.SAVE-CHANGES' | translate }}</button>
    </div>

    <div *ngIf="isDrawingMode" class="toggle-main-button drawing-controls">
        <button mat-flat-button
                *ngIf="drawingType === 'polygon'"
                (click)="undoLastPoint()"
                class="undo-btn" type="button">Undo</button>
        <button mat-flat-button
                (click)="stopAddingField()"
                type="button">Cancel</button>
        <button mat-flat-button
                [disabled]="drawingType === 'polygon' ? drawnPoints.length < 3 : !circleCenter"
                (click)="finishCustomDrawing()"
                type="button">Finish</button>
    </div>

    <div *ngIf="saveEditedField" class="toggle-main-button">
        <button class="cancel-edit" mat-flat-button (click)="cancelEdit()" type="button">
            Cancel
        </button>
        <button class="update-fields" mat-flat-button (click)="updateEditedField()" type="button">
            {{ 'MAPPING.ADD-FIELD' | translate }}
        </button>
    </div>

</div>
</body>
